import { NAVIGATION_URLS } from '@libs/core';

export const generateVelocityCreateAccountUrl = (
    queryKey?: string,
    queryValue?: string
): string => {
    if (typeof window === 'undefined') {
        return '';
    }
    const currentPage = new URL(window.location.href);
    if (queryKey && queryValue) {
        currentPage.searchParams.set(queryKey, queryValue);
    }
    const redirectUrl = encodeURIComponent(
        currentPage.pathname + currentPage.search
    );
    return `${NAVIGATION_URLS.velocity.createAccount}?redirectUrl=${redirectUrl}`;
};
